<template>
  <v-container>
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="lazy"
      @keyup.native.enter="!$v.$invalid && onLogin($event)"
    >
      <v-container>
        <v-alert dense border="top" type="info">
          {{ messageInfo }}
        </v-alert>
        <v-row>
          <v-col :class="classoffset" :cols="ncols">
            <v-text-field
              id="signin__email__text"
              name="signin__email__text"
              autofocus
              v-model="credentials.email"
              :counter="120"
              :error-messages="getErrors('credentials.email', 'El email')"
              label="Email"
              required
              @input="$v.credentials.email.$touch()"
              @blur="$v.credentials.email.$touch()"
              :disabled="isBusy"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col :class="classoffset" :cols="ncols">
            <v-text-field
              id="signin__password__text"
              name="signin__password__text"
              v-model="credentials.password"
              :counter="50"
              :error-messages="
                getErrors('credentials.password', 'La contraseña')
              "
              label="Contraseña"
              required
              @input="$v.credentials.password.$touch()"
              @blur="$v.credentials.password.$touch()"
              :append-icon="showPassword ? icon.eye : icon.eyeOff"
              @click:append="showPassword = !showPassword"
              :type="showPassword ? 'text' : 'password'"
              :disabled="isBusy"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="offset-4" cols="4">
            <v-btn
              id="signin__ingresar__button"
              name="signin__ingresar__button"
              block
              color="secondary"
              @click.prevent="onLogin"
              :disabled="$v.$invalid || isBusy"
              >Ingresar</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-dialog v-model="dialogError" persistent max-width="640">
      <v-card>
        <v-card-title class="headline"
          >Hubo algún problema con su cuenta de Contpaqi Nube</v-card-title
        >
        <v-card-text
          >En este momento cuenta con dos alternativas reintentar su ingreso a
          través de Contpaqi Nube, o bien intente ingresar con su contraseña de
          recuperación</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="signin__reintentar__button" name="signin__reintentar__button" color="blue darken-1" text @click="redirectIdentitySite"
            >Reintentar Contpaqi Nube</v-btn
          >
          <v-btn id="signin__recuperar__button" name="signin__recuperar__button" color="indigo darken-1" text @click="redirectSignin"
            >Usar contraseña de recuperación</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import _ from 'lodash'
import {
  panelActions,
  panelData,
  pushNotification,
  userActions,
  userData
} from '@/store/helpers'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import VuelidateHelper from '@/utils/VuelidateHelper'

export default {
  name: 'Signin',
  data() {
    return {
      icon: {
        eye: mdiEyeOutline,
        eyeOff: mdiEyeOffOutline
      },
      valid: true,
      showPassword: false,
      credentials: {
        email: '',
        password: ''
      },
      lazy: false,
      vuelidateHelper: null,
      messageInfo: `Si usted ve esta pantalla seguramente se debe a intermitencia en alguno de los servidores, sin embargo, este acceso a CONTPAQi® Firma es totalmente funcional y seguro, te recordamos que para este acceso se debe usar la contraseña de respaldo que capturo cuando registro tú cuenta.`,
      dialogError: false
    }
  },
  created() {
    this.vuelidateHelper = new VuelidateHelper(this.$v)
    this.checkParamCode()
  },
  validations: {
    credentials: {
      email: { required, maxLength: maxLength(120), email },
      password: { required, maxLength: maxLength(50) }
    }
  },
  computed: {
    ...panelData,
    ...userData,
    classoffset(){
      return 'offset-' + (this.$vuetify.breakpoint.height <= 720 ? '2' : '3')
    },
    ncols(){
      return this.$vuetify.breakpoint.height <= 720 ? '8' : '6'
    }
  },
  methods: {
    ...panelActions,
    ...userActions,
    onLogin() {
      if (this.$refs.form.validate()) {
        this.panelBusy()
        this.login(this.credentials)
          .then(() => {
            this.panelUnnocupied()
            this.$router.push({ path: '/dashboard' })
          })
          .catch(err => {
            this.panelUnnocupied()
            const errorData = JSON.parse(err.request.response).error
            if (errorData) {
              pushNotification(
                this.$store,
                `${errorData.message}`,
                'error',
                'left'
              )
            } else {
              pushNotification(
                this.$store,
                `El usuario o la contraseña no son correctos`,
                'error',
                'left'
              )
            }
          })
      }
    },
    getErrors(campo, label = '') {
      return this.vuelidateHelper.getErrors(campo, label)
    },
    checkParamCode() {
      if (_.isEmpty(this.$route.query)) {
        return
      }

      if (!_.isEmpty(this.$route.query.error_description)) { 
        if(this.$route.query.error_description.indexOf(this.catchPassReset)>=0) {
          this.redirectPasswordRecoveryIdentity()
          return
        }

        if(this.$route.query.error_description.indexOf(this.catchCancelPassReset)>=0) {
          this.redirectIdentitySite()
          return
        }
      }

      if (this.$route.query.code !== undefined) {
        this.messageInfo = `Se está verificando tu cuenta en CONTPAQi® Firma espera unos momentos por favor...`
        this.panelBusy()
        this.checkIdentityAccount(this.$route.query.code)
          .then(result => {
            const tkn = {
              token: result.data.id_token
            }
            this.loginWithIdentityToken(tkn)
          })
          .catch(err => {
            this.panelUnnocupied()
            if (err.response.status == 400) {
              this.dialogError = true
            } else {
              this.redirectIdentitySite()
            }
          })
      } else {
        this.dialogError = true
      }
    },
    loginWithIdentityToken(data) {
      this.panelBusy()

      this.checkFirmaAccountWithIdentityToken(data)
        .then(result => {
          this.panelUnnocupied()
          this.$router.push({ path: '/dashboard' })
        })
        .catch(err => {
          this.panelUnnocupied()
          if (err.response.status == 404) {
            const signup = '/signup?token=' + data.token
            this.$router.push({ path: signup })
          } else {
            this.redirectIdentitySite()
          }
        })
    },
    redirectIdentitySite() {
      window.location.replace(this.identidadesSingin)
    },
    redirectPasswordRecoveryIdentity() {
      window.location.replace(this.identidadesPasswordRecovery)
    },
    redirectSignin() {
      this.dialogError = false
      this.$router.push({ path: '/signin' })
    }
  }
}
</script>
